import {
  Activity,
  LayoutGrid,
  ShieldCheck,
  Smartphone,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export type NavItem = {
  href: string;
  label: string;
  icon: LucideIcon;
  /** Also mark active for nested routes, e.g. /wallets/app-a. */
  nested?: boolean;
  badgeKey?: "pendingDevices";
};

export type NavGroup = { label: string; items: NavItem[] };

/**
 * The design's nav, rewritten to the routes this app actually declares in
 * `src/routes.tsx`. Two of the design's entries are gone rather than pointed
 * somewhere plausible:
 *
 * - "Users & roles" (`/team`) has no route and no API behind it. A nav item
 *   that lands on a 404 is worse than an absent one.
 * - "Overview" (`/overview`) and "Profile & security" (`/profile`) are this
 *   app's `/` and `/security`; the labels stay, the hrefs move.
 *
 * Anything added here must exist in `routes.tsx`: `UiLink` hands the string
 * straight to the router's untyped `to`, so a wrong href fails at click time,
 * not at compile time.
 */
export const navGroups: NavGroup[] = [
  {
    label: "Platform",
    items: [
      { href: "/", label: "Overview", icon: LayoutGrid },
      { href: "/wallets", label: "Wallets", icon: Wallet, nested: true },
      { href: "/usage", label: "Usage", icon: Activity },
    ],
  },
  {
    label: "Account",
    items: [
      { href: "/security", label: "Profile & security", icon: ShieldCheck },
      {
        href: "/device-approvals",
        label: "Device approvals",
        icon: Smartphone,
        badgeKey: "pendingDevices",
      },
    ],
  },
];
